import {
  AssetRegisterEntry,
  GoodsReceivedNote,
  InventoryItem,
  StockAdjustment,
  StockIssue,
  StockSnapshot,
  StockTransfer
} from '../models/inventory.models';

export const MOCK_INVENTORY_ITEMS: InventoryItem[] = [
  {
    id: '1',
    code: 'PPE-001',
    name: 'Safety Helmet',
    category: 'PPE',
    unit: 'Unit',
    stockLevel: 48,
    reorderLevel: 20,
    price: 185,
    status: 'active',
    icon: 'bi-shield-check'
  },
  {
    id: '2',
    code: 'TOOL-014',
    name: 'Cordless Drill Kit',
    category: 'Tools',
    unit: 'Set',
    stockLevel: 12,
    reorderLevel: 5,
    price: 2499,
    status: 'active',
    icon: 'bi-tools'
  },
  {
    id: '3',
    code: 'AV-012',
    name: 'Wireless Microphone',
    category: 'AV Equipment',
    unit: 'Unit',
    stockLevel: 34,
    reorderLevel: 15,
    price: 890,
    status: 'active',
    icon: 'bi-mic'
  },
  {
    id: '4',
    code: 'AV-018',
    name: 'Portable PA Speaker',
    category: 'AV Equipment',
    unit: 'Unit',
    stockLevel: 8,
    reorderLevel: 4,
    price: 3200,
    status: 'active',
    icon: 'bi-speaker'
  },
  {
    id: '5',
    code: 'OFF-005',
    name: 'A4 Copy Paper (Box)',
    category: 'Office Supplies',
    unit: 'Box',
    stockLevel: 56,
    reorderLevel: 25,
    price: 320,
    status: 'active',
    icon: 'bi-file-earmark'
  },
  {
    id: '6',
    code: 'FUR-008',
    name: 'Folding Chair Set',
    category: 'Furniture',
    unit: 'Set',
    stockLevel: 6,
    reorderLevel: 4,
    price: 890,
    status: 'active',
    icon: 'bi-chair'
  },
  {
    id: '7',
    code: 'IT-003',
    name: 'Network Switch 24-Port',
    category: 'IT Hardware',
    unit: 'Unit',
    stockLevel: 9,
    reorderLevel: 3,
    price: 4150,
    status: 'active',
    icon: 'bi-hdd-network'
  },
  {
    id: '8',
    code: 'CLN-021',
    name: 'Industrial Cleaning Kit',
    category: 'Consumables',
    unit: 'Kit',
    stockLevel: 2,
    reorderLevel: 8,
    price: 450,
    status: 'active',
    icon: 'bi-droplet'
  }
];

export const MOCK_STOCK_SNAPSHOTS: StockSnapshot[] = MOCK_INVENTORY_ITEMS.map((item) => ({
  id: item.id,
  itemCode: item.code,
  itemName: item.name,
  category: item.category,
  location: 'Warehouse A',
  quantity: item.stockLevel,
  unit: item.unit,
  unitValue: item.price,
  stockStatus:
    item.stockLevel <= item.reorderLevel / 2
      ? 'critical'
      : item.stockLevel <= item.reorderLevel
        ? 'low'
        : 'ok'
}));

export const MOCK_ASSET_REGISTER: AssetRegisterEntry[] = [
  {
    id: '1',
    assetTag: 'AST-1001',
    name: 'Cordless Drill Kit',
    category: 'Tools',
    location: 'Warehouse A',
    purchaseDate: '2024-03-12',
    purchaseValue: 2499,
    condition: 'good',
    status: 'active'
  },
  {
    id: '2',
    assetTag: 'AST-1002',
    name: 'Portable PA Speaker',
    category: 'AV Equipment',
    location: 'Sandton Store',
    purchaseDate: '2023-11-05',
    purchaseValue: 3200,
    condition: 'fair',
    status: 'active'
  },
  {
    id: '3',
    assetTag: 'AST-1003',
    name: 'Folding Chair Set',
    category: 'Furniture',
    location: 'Warehouse B',
    purchaseDate: '2022-08-20',
    purchaseValue: 890,
    condition: 'good',
    status: 'active'
  }
];

export const MOCK_GOODS_RECEIVED: GoodsReceivedNote[] = [
  {
    id: '1',
    grnNumber: 'GRN-2026-0143',
    supplier: 'Industrial Supplies SA',
    itemName: 'Safety Boots',
    receivedDate: '2026-06-18',
    items: 24,
    totalValue: 18650,
    status: 'posted'
  },
  {
    id: '2',
    grnNumber: 'GRN-2026-0142',
    supplier: 'AV Pro Distributors',
    itemName: 'Wireless Microphone',
    receivedDate: '2026-06-15',
    items: 8,
    totalValue: 12400,
    status: 'posted'
  },
  {
    id: '3',
    grnNumber: 'GRN-2026-0141',
    supplier: 'Office World',
    itemName: 'A4 Copier Paper',
    receivedDate: '2026-06-10',
    items: 40,
    totalValue: 3200,
    status: 'draft'
  }
];

export const MOCK_STOCK_ISSUES: StockIssue[] = [
  {
    id: '1',
    issueNumber: 'ISS-2026-0090',
    issuedTo: 'JOB-2026-0142',
    branch: 'Sandton Branch',
    itemName: 'White Gloves, Embalming Fluid',
    issueDate: '2026-06-20',
    items: 12,
    totalValue: 2400,
    status: 'issued'
  },
  {
    id: '2',
    issueNumber: 'ISS-2026-0089',
    issuedTo: 'Maintenance Team',
    branch: 'Johannesburg HQ',
    itemName: 'Cleaning Cloths',
    issueDate: '2026-06-19',
    items: 5,
    totalValue: 350,
    status: 'issued'
  }
];

export const MOCK_STOCK_ADJUSTMENTS: StockAdjustment[] = [
  {
    id: '1',
    adjustmentNumber: 'ADJ-2026-0035',
    reason: 'Stock count variance',
    adjustedBy: 'Sarah Mokoena',
    adjustmentDate: '2026-06-17',
    items: 3,
    status: 'pending'
  },
  {
    id: '2',
    adjustmentNumber: 'ADJ-2026-0034',
    reason: 'Damaged goods write-off',
    adjustedBy: 'Tshepo Selomo',
    adjustmentDate: '2026-06-12',
    items: 2,
    status: 'approved'
  }
];

export const MOCK_STOCK_TRANSFERS: StockTransfer[] = [
  {
    id: '1',
    transferNumber: 'TRF-2026-0013',
    fromLocation: 'Warehouse A',
    toLocation: 'Sandton Store',
    transferDate: '2026-06-16',
    items: 10,
    status: 'completed'
  },
  {
    id: '2',
    transferNumber: 'TRF-2026-0012',
    fromLocation: 'Warehouse A',
    toLocation: 'Warehouse B',
    transferDate: '2026-06-14',
    items: 6,
    status: 'in-transit'
  }
];
